import { render, staticRenderFns } from "./ModalScreentimeExhausted.vue?vue&type=template&id=3f7bc4bd&scoped=true&"
import script from "./ModalScreentimeExhausted.vue?vue&type=script&lang=js&"
export * from "./ModalScreentimeExhausted.vue?vue&type=script&lang=js&"
import style0 from "./ModalScreentimeExhausted.vue?vue&type=style&index=0&id=3f7bc4bd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7bc4bd",
  null
  
)

export default component.exports